module.exports = __webpack_public_path__ + "static/media/clap.045156fe.mp3";